import { useTranslation } from "react-i18next";

const AgentStatusOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "ACTIVE",
      title: t("options.status.active"),
      value: "ACTIVE",
    },
    {
      key: "SUSPENDED",
      title: t("options.status.suspended"),
      value: "SUSPENDED",
    },
    {
      key: "TERMINATED",
      title: t("options.status.terminated"),
      value: "TERMINATED",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default AgentStatusOptions;
